<template>
  <div class="level" :class="{ 'qualification-root': isQualificationDetail }" style="width: 100%;">
    <div class="jiangli_top">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <p>{{ $t("m.xiangqing") }}</p>
    </div>
    <div v-if="detailData && isQualificationDetail" class="qualification-page">
      <section class="qualification-hero">
        <div class="qualification-eyebrow">QUALIFICATIONS</div>
        <img :src="qualificationLogo" alt="中国太平洋保险" />
        <h1>公司资质与合规</h1>
        <p>主体登记文件与产品承保公告函公示</p>
        <div class="qualification-status">
          <span>当前状态</span>
          <strong>已公示</strong>
        </div>
      </section>

      <section class="source-panel">
        <div class="source-logo">资质</div>
        <div>
          <h2>资质文件</h2>
          <p>点击下方文件可查看完整原图，文件内容以公示原件为准。</p>
        </div>
      </section>

      <section class="qualification-files">
        <button
          v-for="item in qualificationFiles"
          :key="item.title"
          type="button"
          @click="previewAsset = item"
        >
          <img :src="item.thumb" :alt="item.title" loading="lazy" />
          <span><strong>{{ item.title }}</strong><small>点击查看原图</small></span>
        </button>
      </section>
    </div>
    <div
      v-else-if="detailData"
      class="level_con"
      :class="select ? 'level_con1' : ''"
      :style="{ width: ceshi }"
      @click="double"
    >
      <div style="display: flex; align-items: center; flex-flow: column;">
        <h1
          style="font-size: 0.36rem;margin-bottom:10px;text-align:center;;width: 100%;"
        >
          {{ detailData.title }}
        </h1>
        <div
          style="width: 100%; display: flex; justify-content: space-between; margin: 5px 0 15px 0; font-size: 12px; color: #999"
        >
          <!--          <span>{{$t('m.fx_span3')}}</span>-->
        </div>
      </div>
      <img
        v-if="shouldShowDetailImage(detailData)"
        :src="detailData.image"
        class="detailImage"
      />
      <div v-html="detailData.content" class="content"></div>
    </div>
    <div v-if="previewAsset" class="image-preview" @click.self="previewAsset = null">
      <button type="button" aria-label="关闭" @click="previewAsset = null">×</button>
      <div>
        <img :src="previewAsset.src" :alt="previewAsset.title" />
        <p>{{ previewAsset.title }}</p>
      </div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import { getArticleDetails } from "../../api/public";
import Icon from "vant/lib/icon";
import qualificationLogo from "../../assets/images/qualifications/pacific-insurance-logo.svg";
import caymanIncorporation from "../../assets/images/qualifications/cayman-incorporation.webp";
import caymanIncorporationThumb from "../../assets/images/qualifications/cayman-incorporation-thumb.webp";
import hongKongIncorporation from "../../assets/images/qualifications/hong-kong-incorporation.webp";
import hongKongIncorporationThumb from "../../assets/images/qualifications/hong-kong-incorporation-thumb.webp";
import businessRegistration from "../../assets/images/qualifications/hong-kong-business-registration.webp";
import businessRegistrationThumb from "../../assets/images/qualifications/hong-kong-business-registration-thumb.webp";
import hongKongListing from "../../assets/images/qualifications/hong-kong-listing.webp";
import hongKongListingThumb from "../../assets/images/qualifications/hong-kong-listing-thumb.webp";
import underwritingAnnouncement from "../../assets/images/qualifications/underwriting-announcement.webp";
import underwritingAnnouncementThumb from "../../assets/images/qualifications/underwriting-announcement-thumb.webp";
// import Toast from "vant/lib/toast";
// import "vant/lib/toast/style";
import "vant/lib/icon/style";

export default {
  name: "detail",
  data() {
    return {
      ceshi: "100%",
      select: false,
      detailData: null,
      qualificationRecord: null,
      qualificationLogo,
      previewAsset: null,
      qualificationFiles: [
        { title: "开曼群岛公司注册证书", src: caymanIncorporation, thumb: caymanIncorporationThumb },
        { title: "香港公司注册证明书", src: hongKongIncorporation, thumb: hongKongIncorporationThumb },
        { title: "香港商业登记证", src: businessRegistration, thumb: businessRegistrationThumb },
        { title: "香港交易所上市证明", src: hongKongListing, thumb: hongKongListingThumb },
        { title: "产品承保官方公告函", src: underwritingAnnouncement, thumb: underwritingAnnouncementThumb }
      ]
    };
  },
  components: {
    Icon
  },
  methods: {
    double() {
      this.select = !this.select;

      console.log("栓合计");
    },
    isQualificationArticle(data) {
      return Boolean(data && data.unpublished);
    },
    loadDetail() {
      const legacyQualification = this.$route.query.qualification === "1";
      if (legacyQualification) {
        this.detailData = {
          title: "公司资质",
          unpublished: true
        };
        return;
      }
      const articleId = this.$route.query.id;
      if (!articleId) {
        this.$router.go(-1);
      } else {
        getArticleDetails(articleId)
          .then(res => {
            console.log(res);
            const data = res.data.data;
            this.detailData = data;
          })
          .catch(err => {
            const msg = err && err.response && err.response.data
              ? err.response.data.msg
              : "资料加载失败";
            this.$dialog.error(msg);
          });
      }
    },
    shouldShowDetailImage(data) {
      if (!data || !data.image) {
        return false;
      }
      return !this.getFirstContentImage(data.content);
    },
    getFirstContentImage(content) {
      if (!content || typeof document === "undefined") {
        return "";
      }
      const wrapper = document.createElement("div");
      wrapper.innerHTML = content;
      const image = wrapper.querySelector("img");
      return image ? image.getAttribute("src") || "" : "";
    }
  },
  computed: {
    isQualificationDetail: function() {
      return this.isQualificationArticle(this.detailData);
    },
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return h + ":" + m + ":" + s;
      };
    }
  },
  watch: {
    "$route.fullPath": function() {
      this.loadDetail();
    }
  },
  mounted() {
    this.loadDetail();
  }
};
</script>

<style scoped>
.level_con1 >>> img {
  max-width: 200% !important;
}
.level_con1 >>> .content img {
  max-width: 250% !important;
}

.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
}
.jiangli_top i {
  position: absolute;
  top: 13px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
}
.level_con {
  width: 100%;
  overflow-x: scroll;
  margin-top: 50px;
  padding: 15px;
}
.qualification-root {
  min-height: 100vh;
  background: #f4f6f9;
}
.qualification-page {
  margin-top: 50px;
  padding: 14px 14px 82px;
  color: #162236;
}
.qualification-hero {
  position: relative;
  overflow: hidden;
  min-height: 206px;
  padding: 24px 20px 18px;
  border-radius: 8px;
  color: #fff;
  background:
    linear-gradient(115deg, rgba(255, 255, 255, 0.14) 0 1px, transparent 1px 20px),
    linear-gradient(135deg, #0c2847 0%, #0d6b78 58%, #a87a2a 100%);
  box-shadow: 0 16px 28px rgba(18, 43, 70, 0.18);
}
.qualification-hero::after {
  content: "";
  position: absolute;
  right: -40px;
  bottom: -54px;
  width: 210px;
  height: 154px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  transform: rotate(-16deg);
}
.qualification-eyebrow {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.38);
  border-radius: 4px;
  font-size: 11px;
  letter-spacing: 0;
  color: rgba(255, 255, 255, 0.86);
  background: rgba(255, 255, 255, 0.1);
}
.qualification-hero h1 {
  position: relative;
  z-index: 1;
  margin-top: 14px;
  font-size: 27px;
  line-height: 35px;
  font-weight: 700;
  letter-spacing: 0;
}
.qualification-hero > img {
  position: relative;
  z-index: 1;
  display: block;
  width: 190px;
  height: 48px;
  margin-top: 18px;
  padding: 7px 10px;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.94);
  border-radius: 6px;
}
.qualification-hero p {
  position: relative;
  z-index: 1;
  margin-top: 10px;
  max-width: 270px;
  font-size: 13px;
  line-height: 19px;
  color: rgba(255, 255, 255, 0.8);
  word-break: break-word;
}
.qualification-status {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  padding: 12px 14px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
}
.qualification-status span {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.84);
}
.qualification-status strong {
  font-size: 17px;
  color: #ffd98d;
}
.official-record,
.qualification-summary,
.source-panel {
  margin-top: 14px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(28, 45, 70, 0.08);
}
.official-record {
  padding: 18px 16px 16px;
}
.record-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.record-title-row span {
  font-size: 12px;
  color: #8a95a6;
}
.record-title-row h2 {
  margin-top: 4px;
  font-size: 17px;
  line-height: 24px;
  font-weight: 700;
  color: #162236;
}
.record-title-row button {
  flex: 0 0 auto;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  background: #0f6f74;
}
.record-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 16px;
  border: 1px solid #e6ebf1;
  border-radius: 6px;
  overflow: hidden;
}
.record-grid div {
  min-width: 0;
  padding: 13px 12px;
  border-right: 1px solid #e6ebf1;
  border-bottom: 1px solid #e6ebf1;
  background: #fbfcfe;
}
.record-grid div:nth-child(2n) {
  border-right: 0;
}
.record-grid div:nth-last-child(-n + 2) {
  border-bottom: 0;
}
.record-grid span {
  display: block;
  font-size: 11px;
  line-height: 16px;
  color: #7c8798;
}
.record-grid strong {
  display: block;
  margin-top: 5px;
  font-size: 16px;
  line-height: 22px;
  color: #102033;
  word-break: break-word;
}
.qualification-summary {
  padding: 18px 16px;
}
.section-heading {
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-heading span {
  width: 4px;
  height: 18px;
  border-radius: 2px;
  background: #c99538;
}
.section-heading h2 {
  font-size: 17px;
  line-height: 24px;
  color: #162236;
}
.summary-list {
  margin-top: 14px;
  border-top: 1px solid #edf1f5;
}
.summary-item {
  display: flex;
  gap: 12px;
  padding: 13px 0;
  border-bottom: 1px solid #edf1f5;
}
.summary-item:last-child {
  border-bottom: 0;
}
.summary-item span {
  flex: 0 0 auto;
  width: 30px;
  height: 24px;
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  color: #0f6f74;
  font-size: 12px;
  font-weight: 700;
  background: #e8f5f3;
}
.summary-item p {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 22px;
  color: #445165;
}
.source-panel {
  display: flex;
  gap: 13px;
  padding: 16px;
  align-items: flex-start;
  border-left: 4px solid #0f6f74;
}
.source-logo {
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border-radius: 6px;
  text-align: center;
  line-height: 48px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: #be2f26;
}
.source-panel h2 {
  font-size: 16px;
  line-height: 22px;
  color: #162236;
}
.source-panel p {
  margin-top: 6px;
  font-size: 13px;
  line-height: 21px;
  color: #647084;
}
.qualification-files {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}
.qualification-files button {
  min-width: 0;
  overflow: hidden;
  text-align: left;
  background: #fff;
  border: 1px solid #e0e6ed;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(28, 45, 70, 0.08);
}
.qualification-files button:last-child:nth-child(odd) { grid-column: 1 / -1; }
.qualification-files img {
  display: block;
  width: 100%;
  height: 190px;
  object-fit: contain;
  background: #edf1f5;
}
.qualification-files span { display: flex; padding: 12px 10px; flex-direction: column; gap: 5px; }
.qualification-files strong { color: #243447; font-size: 13px; line-height: 19px; }
.qualification-files small { color: #3976ad; font-size: 11px; }
.image-preview {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  padding: 56px 12px 24px;
  align-items: flex-start;
  justify-content: center;
  overflow: auto;
  background: rgba(2, 8, 16, 0.94);
}
.image-preview > button {
  position: fixed;
  z-index: 2;
  top: 12px;
  right: 16px;
  width: 36px;
  height: 36px;
  color: #fff;
  font-size: 30px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.14);
  border: 0;
  border-radius: 50%;
}
.image-preview > div { width: 100%; max-width: 720px; text-align: center; }
.image-preview img { display: block; width: 100%; height: auto; background: #fff; border-radius: 7px; }
.image-preview p { margin-top: 12px; color: #fff; font-size: 13px; }
.business-introduction-hero {
  position: relative;
  width: 100%;
  min-height: 180px;
  overflow: hidden;
  background-position: center;
  background-size: cover;
  border: 1px solid rgba(55, 131, 196, 0.28);
  border-radius: 10px;
  box-shadow: 0 14px 30px rgba(12, 48, 82, 0.18);
}
.business-hero-shade {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 50% 42%, rgba(27, 142, 220, 0.22), transparent 38%),
    linear-gradient(90deg, rgba(4, 23, 47, 0.68), rgba(6, 54, 95, 0.16));
}
.business-hero-copy {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  text-shadow: 0 3px 14px rgba(0, 20, 45, 0.5);
}
.business-hero-copy strong {
  font-size: 46px;
  line-height: 1;
  font-weight: 300;
}
.business-hero-copy h2 {
  margin-top: 8px;
  font-size: 24px;
  line-height: 1.2;
  letter-spacing: 2px;
}
.business-hero-copy span {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 10px;
  letter-spacing: 2px;
}
.detailImage {
  max-width: 100%;
  border-radius: 5px;
  display: inline-block;
  height: auto;
}
.content >>> img {
  max-width: 100% !important;
  display: inline-block !important;
  height: auto !important;
}
</style>

